/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';

export const primary: ThemeUICSSObject = {
  background: 'palette.background.paper',
  border: '1px solid',
  borderColor: 'palette.border.field',
  borderRadius: 'tooltips',
  color: 'palette.text.primary',
  p: 3,
  zIndex: 'tooltip',
  /* PREPEND HERE */
};
